import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PupCard from '../pupCards/PupCard';
import './PupCardDetail.css';

// Lightweight card-detail modal opened by clicking a Pup card name in the ActionLog. There is no
// pre-existing detail view, so this wraps the full-size <PupCard> renderer (which resolves the code
// from the cached catalog and self-heals an unknown code). Portaled to <body> so it escapes the
// table's overflow:hidden clip and centers on the viewport. Closes on backdrop click, the X, or Esc.
// `roomId` rides through to PupCard so table-type-dependent text (the tournament removal note)
// renders correctly.
const PupCardDetail = ({ code, onClose, roomId }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="pup-card-detail-overlay" onClick={onClose}>
      <div
        className="pup-card-detail-inner"
        role="dialog"
        aria-modal="true"
        aria-label="Power-Up card detail"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="pup-card-detail-close" onClick={onClose} aria-label="Close card detail">
          &times;
        </button>
        <PupCard code={code} roomId={roomId} />
      </div>
    </div>,
    document.body,
  );
};

export default PupCardDetail;
